import axios from 'axios';
import { BaseApiUrlKey, HokhuwaApiUrlKey } from '../../global-key';

const baseApi = axios.create({
    baseURL: BaseApiUrlKey,
});


baseApi.interceptors.request.use(config => {

    config.headers['Content-Type'] = 'application/json';
    config.headers['X-CyTech-Key'] = "369db676-522d-495d-aefd-4a067e2a5c92";
    config.headers['ref-id'] = new URLSearchParams(window.location.search).get("ref-id") || 'no-client-id';
    return config;
});



const hokhuwaApi = axios.create({
    baseURL: HokhuwaApiUrlKey,
    timeout: 100000
})


hokhuwaApi.interceptors.request.use(config => {

    config.headers['Content-Type'] = 'application/json';
    config.headers['X-CyTech-Key'] = new URLSearchParams(window.location.search).get("hokhuwa-key") || 'no-client-id';
    config.headers['ref-id'] = new URLSearchParams(window.location.search).get("ref-id") || 'no-client-id';
    return config;
});


export {
    baseApi,
    hokhuwaApi
};
